import { render, staticRenderFns } from "./TheSnapshotFileEditor.vue?vue&type=template&id=a6197e8e&"
import script from "./TheSnapshotFileEditor.vue?vue&type=script&lang=js&"
export * from "./TheSnapshotFileEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports